import { render, staticRenderFns } from "./LeGamePhotoGallery.vue?vue&type=template&id=329f8988"
import script from "./LeGamePhotoGallery.vue?vue&type=script&lang=js"
export * from "./LeGamePhotoGallery.vue?vue&type=script&lang=js"
import style0 from "./LeGamePhotoGallery.vue?vue&type=style&index=0&id=329f8988&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports